import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const KineticText = ({ children, as: Tag = "p", className = "", delay = 0, splitBy = "word", shimmer = false }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const text = el.textContent;
    let parts;
    
    if (splitBy === "char") {
      parts = text.split("");
    } else {
      parts = text.split(" ");
    }
    
    el.innerHTML = parts
      .map((part) => {
        const isSpace = part === " " || part === "";
        const spaceHtml = isSpace ? "&nbsp;" : "";
        if (splitBy === "word") {
           return `<span class="kinetic-word" style="display:inline-block;overflow:hidden;vertical-align:bottom;"><span class="kinetic-inner ${shimmer ? 'kinetic-shimmer' : ''}" style="display:inline-block;transform:translateY(100%);opacity:0;">${part}&nbsp;</span></span>`;
        } else {
           return `<span class="kinetic-word" style="display:inline-block;overflow:hidden;vertical-align:bottom;"><span class="kinetic-inner ${shimmer ? 'kinetic-shimmer' : ''}" style="display:inline-block;transform:translateY(100%);opacity:0;">${part === " " ? "&nbsp;" : part}</span></span>`;
        }
      })
      .join("");

    const ctx = gsap.context(() => {
      const inners = el.querySelectorAll(".kinetic-inner");
      gsap.to(inners, {
        y: 0,
        opacity: 1,
        duration: 0.9,
        stagger: splitBy === "char" ? 0.02 : 0.04,
        ease: "power3.out",
        delay,
        scrollTrigger: {
          trigger: el,
          start: "top 88%",
          toggleActions: "play none none reverse",
        },
      });
    });

    return () => ctx.revert();
  }, [children, delay, splitBy, shimmer]);

  return <Tag ref={ref} className={className}>{children}</Tag>;
};

export default KineticText;
